import { useTranslation } from 'next-i18next';
import React from 'react';
import { TFdrThGeoModuleObjectWithChildren } from 'components/domain/fdr-geo/fdr-geo.types';
import { FdrCommonGridRecommenderUnpaginated } from 'components/domain/fdr-page-components/recommenders/common/fdr-common-grid-recommender-unpaginated';
import { FdrGeoRecommenderItem } from 'components/domain/fdr-page-components/recommenders/geo/fdr-geo-recommender-item';
import { NavigationIds } from './navigation/fdr-geo-navigation.types';

interface IGeoChildrenProps {
  geoChildren: TFdrThGeoModuleObjectWithChildren['children'];
  geoName?: string;
}

const FdrGeoChildren: React.FC<IGeoChildrenProps> = ({
  geoChildren,
  geoName,
}) => {
  const [t] = useTranslation('common');

  return (
    <FdrCommonGridRecommenderUnpaginated
      items={geoChildren.page.map(i => ({
        ...i,
        image: i.hero,
        title: i.name,
        link: i.webMeta.descriptionWebMeta.link,
      }))}
      title={`${t('geoRecos.title')}` + (geoName ? ` ${geoName}` : '')}
      id={NavigationIds.DESTINATIONS}
      recommendationItem={FdrGeoRecommenderItem}
    />
  );
};

export default FdrGeoChildren;
